module.exports = __webpack_public_path__ + "static/media/logo_ecmwf.75647ca1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_ecmwf.png
// module id = 237
// module chunks = 0